import * as React from 'react';
import { Box, Button } from 'wix-style-react';
function ReviewAppPageFooter(_a) {
    var onSubmitButtonClick = _a.onSubmitButtonClick, t = _a.t;
    var submitReviewButtonText = t('review-app.submit-review');
    return (React.createElement(Box, { align: "right" },
        React.createElement(Box, { marginLeft: "12px" },
            React.createElement(Button, { size: "small", priority: "primary", onClick: onSubmitButtonClick }, submitReviewButtonText))));
}
export { ReviewAppPageFooter };
//# sourceMappingURL=review-app-page-footer.js.map